import store from '../store'

export default (to, from, next) => {
    if (to.meta.public) return next()
    store.dispatch('auth/fetchUser').then(() => {
        if (to.name.startsWith('auth') && to.name !== 'auth_SignOut') {
            next({ name: 'Mypools' })
        } else {
            if (!!from.query.user && !to.query.user) {
                next({ ...to, query: { username: from.query.user } })
            } else {
                next()
            }
        }
    }).catch(() => {
        if (to.name && !to.name.startsWith('auth')) {
            store.dispatch('auth/setRedirectPath', to.fullPath)
            next('/auth/signIn')
        } else {
            next()
        }
    })
}
